/* ============================================================================
   NAMING THIS LATER — PRODUCT FOLD  (playbook §5.3 · §5.6)
   Its OWN deferred asset, deliberately NOT part of the shared per-section
   javascript bundle: a throw anywhere else can never kill the buy box.
   Self-initialises on every [data-ntl-pfold] root on DOMContentLoaded and on
   shopify:section:load, guarded by data-ntl-pfold-init.

   Owns: gallery (cross-fade slides, arrows with wrap-around, swipe, keyboard,
   thumbnail rail with desktop paging + mobile auto-centre), hover zoom,
   lightbox (focus trap, ESC, arrows, swipe, pinch/wheel zoom + pan, counter,
   focus restore), the variant picker, and the "Buy together" multi-add.

   Does NOT own: add-to-cart, the qty stepper, accordions, toasts, the cart
   drawer — those are ntl-common.js delegation and are never reimplemented here.
   ========================================================================= */
(function () {
  'use strict';

  var CART_SECTIONS = ['cart-count-badge', 'offcanvas-cart'];
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE    = window.matchMedia('(hover:hover) and (pointer:fine)');

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) {
    if (window.NTL && typeof NTL.money === 'function') return NTL.money(c);
    return '$' + (Number(c || 0) / 100).toFixed(2);
  }
  function toast(msg, kind) {
    if (window.NTL && typeof NTL.toast === 'function') NTL.toast(msg, kind);
  }
  function behavior() { return REDUCED.matches ? 'auto' : 'smooth'; }

  /* ── cart helpers — reuse the theme's engine, never its UI (§5.5) ─────── */
  function cartAdd(items) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) || '/cart/add';
    return fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: CART_SECTIONS.join(','),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }
  function afterAdd(payload) {
    var host = document.querySelector('cart-container');
    if (host && payload && payload.sections && typeof host.reloadCartElements === 'function') {
      try { host.reloadCartElements(payload.sections); } catch (e) {}
    }
    try { window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: payload })); } catch (e) {}
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.NTL && NTL.syncCartCounts) NTL.syncCartCounts(cart.item_count);
      })
      .catch(function () {});
  }

  /* ══════════════════════════════════════════════════════════════════════ */
  function init(root) {
    if (!root || root.dataset.ntlPfoldInit === '1') return;
    root.dataset.ntlPfoldInit = '1';

    var data = {};
    var tag = root.querySelector('[data-pf-data]');
    if (tag) { try { data = JSON.parse(tag.textContent || '{}') || {}; } catch (e) { data = {}; } }

    var variants = data.variants || [];
    var mediaIds = data.media || [];
    var sel      = (data.sel || []).slice();
    var loop     = data.loop !== false;

    /* ── GALLERY ───────────────────────────────────────────────────────── */
    var stage   = root.querySelector('[data-pf-stage]');
    var slides  = $$('[data-pf-slide]', root);
    var strip   = root.querySelector('[data-pf-strip]');
    var thumbs  = $$('[data-pf-thumb]', root);
    var counter = root.querySelector('[data-pf-count]');
    var live    = root.querySelector('[data-pf-live]');
    var tprev   = root.querySelector('[data-pf-tprev]');
    var tnext   = root.querySelector('[data-pf-tnext]');
    var at = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) at = i; });

    function stripHoriz() {
      if (!strip) return false;
      return getComputedStyle(strip).flexDirection.indexOf('row') === 0;
    }
    /* scroll the RAIL only, never the page — rect maths so an unpositioned
       offsetParent can never send it somewhere silly */
    function centreThumb(i) {
      if (!strip || !thumbs[i]) return;
      var tr = thumbs[i].getBoundingClientRect();
      var sr = strip.getBoundingClientRect();
      if (stripHoriz()) {
        var dx = (tr.left + tr.width / 2) - (sr.left + sr.width / 2);
        if (Math.abs(dx) > 1) strip.scrollBy({ left: dx, behavior: behavior() });
      } else {
        var dy = (tr.top + tr.height / 2) - (sr.top + sr.height / 2);
        if (Math.abs(dy) > 1) strip.scrollBy({ top: dy, behavior: behavior() });
      }
    }
    function syncThumbNav() {
      if (!strip || !tprev || !tnext) return;
      var horiz = stripHoriz();
      var scrollable = horiz
        ? strip.scrollWidth > strip.clientWidth + 2
        : strip.scrollHeight > strip.clientHeight + 2;
      /* desktop only: on touch the rail auto-centres instead */
      var visible = scrollable && !horiz;
      tprev.hidden = !visible;
      tnext.hidden = !visible;
      if (!visible) return;
      var pos = horiz ? strip.scrollLeft : strip.scrollTop;
      var max = horiz ? strip.scrollWidth - strip.clientWidth : strip.scrollHeight - strip.clientHeight;
      tprev.disabled = pos <= 1;
      tnext.disabled = pos >= max - 1;
    }
    function pageThumbs(dir) {
      if (!strip || !thumbs.length) return;
      var per = Math.max(1, (Number(data.thumbsVisible) || 5) - 1);
      var box = thumbs[0].getBoundingClientRect();
      var horiz = stripHoriz();
      var step = ((horiz ? box.width : box.height) + 8) * per;
      var opt = horiz ? { left: dir * step } : { top: dir * step };
      opt.behavior = behavior();
      strip.scrollBy(opt);
    }
    function clearZoom() {
      slides.forEach(function (s) { s.style.transform = ''; s.style.transformOrigin = ''; });
      if (stage) stage.classList.remove('zooming');
    }
    function show(i, announce) {
      if (!slides.length) return;
      var n = slides.length;
      i = loop ? ((i % n) + n) % n : Math.min(Math.max(i, 0), n - 1);
      at = i;
      clearZoom();
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('on', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      if (live && announce) live.textContent = 'Image ' + (i + 1) + ' of ' + n;
      centreThumb(i);
      syncThumbNav();
    }

    if (strip) {
      strip.addEventListener('scroll', syncThumbNav, { passive: true });
      window.addEventListener('resize', syncThumbNav);
    }

    /* ── HOVER ZOOM — off on touch and under reduced motion ────────────── */
    var zoomScale = Number(data.zoomScale) || 2;
    var canZoom = data.zoom !== false && FINE.matches && !REDUCED.matches && slides.length > 0;
    function setStageZoom(v) {
      var a = slides[at];
      if (!a) return;
      if (v === 1) { a.style.transform = ''; a.style.transformOrigin = ''; }
      else a.style.transform = 'scale(' + v + ')';
    }
    if (stage && canZoom) {
      stage.addEventListener('mouseenter', function () {
        if (lbOpen) return;
        stage.classList.add('zooming');
        setStageZoom(zoomScale);
      });
      stage.addEventListener('mousemove', function (e) {
        if (lbOpen) return;
        /* pause the magnifier while the cursor is over an arrow */
        if (e.target.closest && e.target.closest('[data-pf-nav]')) {
          stage.classList.remove('zooming');
          setStageZoom(1);
          return;
        }
        stage.classList.add('zooming');
        setStageZoom(zoomScale);
        var r = stage.getBoundingClientRect();
        var a = slides[at];
        if (!a || !r.width || !r.height) return;
        a.style.transformOrigin =
          (((e.clientX - r.left) / r.width) * 100).toFixed(2) + '% ' +
          (((e.clientY - r.top) / r.height) * 100).toFixed(2) + '%';
      });
      stage.addEventListener('mouseleave', clearZoom);
    }

    /* ── SWIPE on the stage ────────────────────────────────────────────── */
    var swiped = false, sx0 = null, sy0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { sx0 = null; return; }
        sx0 = e.touches[0].clientX; sy0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx0 === null) return;
        var dx = e.changedTouches[0].clientX - sx0;
        var dy = e.changedTouches[0].clientY - sy0;
        sx0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        swiped = true;
        setTimeout(function () { swiped = false; }, 400);
        show(at + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
    }

    /* ── KEYBOARD on the media column ─────────────────────────────────── */
    var mediaCol = root.querySelector('.fmedia');
    if (mediaCol) {
      mediaCol.addEventListener('keydown', function (e) {
        if (lbOpen) return;
        if (e.key === 'ArrowLeft')  { show(at - 1, true); e.preventDefault(); }
        if (e.key === 'ArrowRight') { show(at + 1, true); e.preventDefault(); }
        if ((e.key === 'Enter' || e.key === ' ') && e.target === stage) {
          openLb(at, stage); e.preventDefault();
        }
      });
    }

    /* ── LIGHTBOX ──────────────────────────────────────────────────────── */
    var lb       = root.querySelector('[data-pf-lb]');
    var lbImg    = lb && lb.querySelector('[data-pf-lb-img]');
    var lbStage  = lb && lb.querySelector('[data-pf-lb-stage]');
    var lbCount  = lb && lb.querySelector('[data-pf-lb-count]');
    var lbOpen   = false;
    var lbTrig   = null;
    var lbAt = 0, z = 1, px = 0, py = 0, dragging = false, dx0 = 0, dy0 = 0, pinch = null;
    /* Was the pointer moved between down and up? A click that follows a drag or a
       swipe must not also toggle the zoom — the shopper was panning the picture or
       flicking to the next one, not asking for anything. */
    var downX = 0, downY = 0, moved = false, downOn = null;

    function paint() {
      if (!lbImg) return;
      lbImg.style.transform = 'translate(' + px + 'px,' + py + 'px) scale(' + z + ')';
      if (lbStage) lbStage.classList.toggle('zoomed', z > 1);
    }
    function setZ(v, ox, oy) {
      if (!lbStage) return;
      var prev = z;
      z = Math.min(Math.max(v, 1), 2.6);
      if (z === 1) { px = 0; py = 0; }
      else if (ox !== undefined) {
        var r = lbStage.getBoundingClientRect();
        px = (px - (ox - r.left - r.width / 2)) * (z / prev) + (ox - r.left - r.width / 2);
        py = (py - (oy - r.top - r.height / 2)) * (z / prev) + (oy - r.top - r.height / 2);
      }
      paint();
    }
    function lbGoto(i) {
      if (!slides.length || !lbImg) return;
      var n = slides.length;
      lbAt = ((i % n) + n) % n;
      var src = slides[lbAt].getAttribute('data-full') || slides[lbAt].currentSrc || slides[lbAt].src;
      lbImg.src = src;
      lbImg.alt = slides[lbAt].getAttribute('alt') || '';
      if (lbCount) lbCount.textContent = (lbAt + 1) + ' / ' + n;
      z = 1; px = 0; py = 0; paint();
      show(lbAt, false);
    }
    function focusables() {
      return $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', lb)
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }
    function trap(e) {
      if (!lbOpen) return;
      if (e.key === 'Escape') { closeLb(); return; }
      if (e.key === 'ArrowLeft')  { lbGoto(lbAt - 1); return; }
      if (e.key === 'ArrowRight') { lbGoto(lbAt + 1); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    function openLb(i, trigger) {
      if (!lb || data.lightbox === false) return;
      lbTrig = trigger || document.activeElement;
      lb.hidden = false;
      lbOpen = true;
      lbGoto(i);
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', trap);
      requestAnimationFrame(function () {
        lb.classList.add('is-on');
        var close = lb.querySelector('[data-pf-lb-close]');
        if (close) { try { close.focus(); } catch (e) {} }
      });
    }
    function closeLb() {
      if (!lb || !lbOpen) return;
      lbOpen = false;
      lb.classList.remove('is-on');
      document.removeEventListener('keydown', trap);
      document.documentElement.style.overflow = '';
      var hide = function () { lb.hidden = true; };
      if (REDUCED.matches) hide(); else setTimeout(hide, 250);
      if (lbTrig && lbTrig.focus) { try { lbTrig.focus(); } catch (e) {} }
      lbTrig = null;
    }
    if (lbStage) {
      lbStage.addEventListener('wheel', function (e) {
        e.preventDefault();
        setZ(z + (e.deltaY < 0 ? 0.3 : -0.3), e.clientX, e.clientY);
      }, { passive: false });
      /* CLICK the picture to zoom, which is what everyone tries first. Before this
         a click on the stage fell through to the backdrop handler and CLOSED the
         viewer, and a click on the image did nothing at all — so the one gesture a
         shopper reaches for was the one that threw the picture away.
         Double-click is gone with it: with click toggling, a double click toggled
         twice and landed back where it started. */
      /* WHERE THE PRESS STARTED, not where the click landed.
         Once the picture is zoomed, pointerdown captures the pointer so panning
         keeps working past the edge of the stage — and the spec then fires the
         following `click` at the CAPTURE TARGET, the stage, rather than at the
         image. Testing e.target therefore failed to recognise a click on the
         picture and the backdrop handler below closed the viewer instead: zoom in
         worked, zoom out threw the picture away. */
      lbStage.addEventListener('click', function (e) {
        if (moved) return;                       /* a drag or a swipe, not a click */
        if (downOn !== lbImg) return;            /* off the picture: the backdrop closes */
        setZ(z > 1 ? 1 : 2.2, e.clientX, e.clientY);
      });
      lbStage.addEventListener('pointerdown', function (e) {
        downX = e.clientX; downY = e.clientY; moved = false; downOn = e.target;
        if (z <= 1) { dx0 = e.clientX; dy0 = e.clientY; return; }
        dragging = true; dx0 = e.clientX - px; dy0 = e.clientY - py;
        try { lbStage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      lbStage.addEventListener('pointermove', function (e) {
        /* tracked whether or not we are dragging, because a swipe at zoom 1 also
           has to suppress the click */
        if (!moved && Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > 6) {
          moved = true;
        }
        if (!dragging) return;
        px = e.clientX - dx0; py = e.clientY - dy0; paint();
      });
      lbStage.addEventListener('pointerup', function (e) {
        if (!dragging && z === 1 && Math.abs(e.clientX - dx0) > 45) {
          lbGoto(lbAt + (e.clientX < dx0 ? 1 : -1));
        }
        dragging = false;
        /* hand the pointer back, or the stage keeps receiving events it no longer
           has any use for */
        try { lbStage.releasePointerCapture(e.pointerId); } catch (err) {}
      });
      lbStage.addEventListener('pointercancel', function () { dragging = false; });
      lbStage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          pinch = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                             e.touches[0].clientY - e.touches[1].clientY);
        }
      }, { passive: true });
      lbStage.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 2 || !pinch) return;
        e.preventDefault();
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                           e.touches[0].clientY - e.touches[1].clientY);
        setZ(z * (d / pinch),
             (e.touches[0].clientX + e.touches[1].clientX) / 2,
             (e.touches[0].clientY + e.touches[1].clientY) / 2);
        pinch = d;
      }, { passive: false });
      lbStage.addEventListener('touchend', function () { pinch = null; });
    }
    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-pf-lb-close]')) { closeLb(); return; }
        if (e.target.closest('[data-pf-lb-prev]'))  { lbGoto(lbAt - 1); return; }
        if (e.target.closest('[data-pf-lb-next]'))  { lbGoto(lbAt + 1); return; }
        if (e.target === lb || e.target === lbStage) {
          /* Same retargeting problem from the other side: a click that began on the
             picture arrives here labelled as the stage. It must not close.
             A drag or a swipe must not close either — the shopper was moving the
             picture, not dismissing it. */
          if (moved || downOn === lbImg) return;
          closeLb();
        }
      });
    }

    /* ── VARIANT PICKER (§5.3) ─────────────────────────────────────────── */
    var idInput  = root.querySelector('[data-pf-vid]');
    var priceEl  = root.querySelector('[data-pf-price]');
    var saveEl   = root.querySelector('[data-pf-save]');
    var atc      = root.querySelector('[data-pf-atc]');
    /* Re-queried every time, never cached. The shared add-to-cart handler in
       ntl-common.js restores the button's innerHTML ~1.2s after a successful add,
       which detaches this span — a cached reference stays truthy, so every later
       "Sold out"/"Unavailable" was written into a node no longer on the page and
       the button kept reading "Add to cart". ntl-sticky-atc.liquid already guards
       against exactly this; the buy box did not. */
    function atcLabelEl() { return root.querySelector('[data-pf-atc-label]'); }
    var buyLive  = root.querySelector('[data-pf-buy-live]');
    var pbuy     = root.querySelector('.pbuy');
    var lowEl    = root.querySelector('[data-pf-low]');
    /* the measured size under the picker — "z" on each variant, resolved in Liquid
       by snippets/ntl-product-size.liquid so JS never has to parse a size string */
    var sizeRow  = root.querySelector('[data-pf-size]');
    var sizeVal  = sizeRow && sizeRow.querySelector('[data-pf-size-v]');
    /* the composition, "mt" on each variant, resolved by ntl-product-material */
    var matRow   = root.querySelector('[data-pf-material]');
    var matVal   = matRow && matRow.querySelector('[data-pf-material-v]');

    function sameOptions(v, vals) {
      for (var k = 0; k < vals.length; k++) {
        if (String(v.o[k]) !== String(vals[k])) return false;
      }
      return true;
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        if (sameOptions(variants[i], vals)) return variants[i];
      }
      return null;
    }
    function firstWith(pos, val) {
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].o[pos - 1]) === String(val) && variants[i].a) return variants[i];
      }
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].o[pos - 1]) === String(val)) return variants[i];
      }
      return null;
    }

    function syncChoices() {
      $$('[data-pf-choice]', root).forEach(function (a) {
        var pos = Number(a.dataset.pfPos);
        var val = a.dataset.pfVal;
        var on  = String(sel[pos - 1]) === String(val);
        a.classList.toggle('on', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        var combo = sel.slice();
        combo[pos - 1] = val;
        var t = findVariant(combo) || firstWith(pos, val);
        a.classList.toggle('is-oos', !(t && t.a));
        if (t) a.href = (data.url || window.location.pathname) + '?variant=' + t.id;
      });
      $$('[data-pf-opt]', root).forEach(function (o) {
        var pos = Number(o.dataset.pfPos);
        var b = o.querySelector('[data-pf-optval]');
        if (b) b.textContent = sel[pos - 1] == null ? '' : sel[pos - 1];
      });
      $$('[data-pf-select]', root).forEach(function (s) {
        var pos = Number(s.dataset.pfPos);
        if (sel[pos - 1] != null) s.value = sel[pos - 1];
      });
    }

    function applyLow(v) {
      if (!lowEl) return;
      var thr = Number(lowEl.dataset.pfLowThreshold) || 6;
      var ok = !!v && v.im === 'shopify' && v.ip === 'deny' && v.iq > 0 && v.iq <= thr;
      lowEl.hidden = !ok;
      if (!ok) return;
      var t = lowEl.querySelector('[data-pf-low-t]');
      var b = lowEl.querySelector('[data-pf-low-b]');
      if (t) t.textContent = (lowEl.dataset.pfLowTpl || 'Only [count] left').replace('[count]', v.iq);
      if (b) b.style.setProperty('--ntl-pfold-lowfill',
        String(Math.min(100, Math.max(8, Math.round(v.iq / thr * 100))) / 100));
    }

    function apply(v, pushUrl) {
      if (idInput) idInput.value = v ? v.id : '';

      if (priceEl && v) {
        priceEl.innerHTML = (v.c && v.c > v.p ? '<s>' + money(v.c) + '</s>' : '') + money(v.p);
      }
      if (saveEl) saveEl.hidden = !(v && v.c && v.c > v.p);

      if (atc) {
        var L = pbuy ? pbuy.dataset : {};
        var txt;
        if (!v)        { txt = L.pfLabelsUnavailable || 'Unavailable'; atc.disabled = true; }
        else if (!v.a) { txt = L.pfLabelsSoldout     || 'Sold out';    atc.disabled = true; }
        else           { txt = L.pfLabelsAdd         || 'Add to cart'; atc.disabled = false; }
        var lbl = atcLabelEl();
        if (lbl) lbl.textContent = txt; else atc.textContent = txt;
      }

      applyLow(v);

      /* the quick-specs "Size" row is rendered from the same resolver, so it has to
         move with the picker — otherwise the two disagree the moment a variant changes */
      var specSize = root.querySelector('[data-pf-spec-size]');
      if (specSize) {
        var sz = v && v.z ? String(v.z) : '';
        specSize.textContent = sz;
        var specRow = specSize.parentElement;
        if (specRow) specRow.hidden = !sz;
      }

      if (sizeRow && sizeVal) {
        var z = v && v.z ? String(v.z) : '';
        sizeVal.textContent = z;
        /* a variant with no size of its own hides the line rather than showing
           another variant's measurement next to it */
        sizeRow.hidden = !z;
      }

      if (matRow && matVal) {
        var mt = v && v.mt ? String(v.mt) : '';
        matVal.textContent = mt;
        /* same rule as the size line: no composition for THIS variant means no
           line, never the previous variant's fibre left standing */
        matRow.hidden = !mt;
      }

      if (v && v.m != null) {
        var mi = mediaIds.indexOf(v.m);
        if (mi > -1) show(mi, false);
      }

      /* the "Buy together" card follows the chosen variant: id AND combined price */
      var box = root.querySelector('[data-pf-bundle]');
      if (box && v) {
        box.dataset.pfBundleMain = v.id;
        var totalEl = box.querySelector('[data-pf-bundle-total]');
        if (totalEl && totalEl.dataset.pfBundleTpl) {
          var mp = Number(box.dataset.pfBundleMatePrice) || 0;
          totalEl.textContent = totalEl.dataset.pfBundleTpl.replace('[total]', money(v.p + mp));
        }
      }

      /* apply() runs ONLY from choose(), i.e. only when the shopper picks something —
         never on load — so this can speak unconditionally without announcing the page
         to itself. Order is what changed, most important first. */
      if (buyLive) {
        var said = [];
        var chosen = sel.filter(Boolean).join(', ');
        if (chosen) said.push(chosen);
        var lbl2 = atcLabelEl();
        if (lbl2) said.push(lbl2.textContent);
        /* from the variant, not the element: priceEl's text is "<s>$255.00</s>$215.00",
           which reads out as "$255.00$215.00" with the two prices run together */
        if (v) said.push(v.c && v.c > v.p ? money(v.p) + ', reduced from ' + money(v.c) : money(v.p));
        if (sizeRow && !sizeRow.hidden && sizeVal && sizeVal.textContent) said.push(sizeVal.textContent);
        buyLive.textContent = said.join(' — ');
      }

      if (v && pushUrl && window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({ variant: v.id }, '', u.toString());
        } catch (e) {}
      }
    }

    function choose(pos, val) {
      sel[pos - 1] = val;
      syncChoices();
      /* no variant for this combination → honestly Unavailable + disabled */
      apply(findVariant(sel), true);
    }

    /* ── BUY TOGETHER — one /cart/add.js with items[] ──────────────────── */
    function bundleAdd(btn) {
      var box = btn.closest('[data-pf-bundle]');
      if (!box) return;
      var errBox = box.querySelector('[data-pf-bundle-err]');
      var msgEl  = box.querySelector('[data-pf-bundle-msg]');
      function say(m) { if (msgEl) msgEl.textContent = m; if (errBox) errBox.hidden = false; }
      function quiet() { if (errBox) errBox.hidden = true; }
      function done(cls) {
        btn.classList.remove('is-loading');
        if (cls) btn.classList.add(cls);
        setTimeout(function () { btn.classList.remove('is-ok', 'is-err'); btn.disabled = false; }, 1200);
      }

      quiet();
      btn.classList.add('is-loading');
      btn.disabled = true;

      var mainId = Number(idInput && idInput.value) || Number(box.dataset.pfBundleMain);
      var mateId = Number(box.dataset.pfBundleMate);
      var qtyEl  = root.querySelector('input[name="quantity"]');
      var qty    = Math.max(1, Number(qtyEl && qtyEl.value) || 1);
      var mainV  = findVariant(sel);
      var mainTitle = (root.querySelector('.pdp-h1') || {}).textContent || 'This item';
      var mateTitle = (box.querySelector('.bndl-b b') || {}).textContent || 'The companion';
      var oosTpl = box.dataset.pfBundleOos  || '[title] is sold out.';
      var haveTx = box.dataset.pfBundleHave || 'Both pieces are already in your cart.';
      var failTx = box.dataset.pfBundleFail || 'We could not add both pieces. Please try again.';

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (l) { have[l.variant_id] = true; });

          var items = [], names = [];
          /* skip sold-out and already-in-cart lines */
          if (mainId && !have[mainId] && (!mainV || mainV.a)) {
            items.push({ id: mainId, quantity: qty }); names.push(mainTitle.trim());
          }
          if (mateId && !have[mateId]) {
            items.push({ id: mateId, quantity: 1 }); names.push(mateTitle.trim());
          }
          if (!items.length) { say(haveTx); done('is-err'); return null; }

          return cartAdd(items).then(function (res) {
            if (res.ok) return afterAdd(res.data).then(function () { done('is-ok'); openDrawer(); });
            /* atomic add refused → retry one line at a time so we can name
               exactly which piece failed (precise partial-failure reporting) */
            return sequential(box, items, names, oosTpl, failTx, done);
          });
        })
        .catch(function () { say(failTx); done('is-err'); });
    }
    function openDrawer() {
      if (window.NTL && typeof NTL.openCartDrawer === 'function') NTL.openCartDrawer();
    }
    function sequential(box, items, names, oosTpl, failTx, done) {
      var okNames = [], badNames = [], last = null;
      var chain = Promise.resolve();
      items.forEach(function (it, i) {
        chain = chain.then(function () {
          return cartAdd([it]).then(function (res) {
            if (res.ok) { okNames.push(names[i]); last = res.data; }
            else badNames.push(names[i]);
          }).catch(function () { badNames.push(names[i]); });
        });
      });
      return chain.then(function () {
        var errBox = box && box.querySelector('[data-pf-bundle-err]');
        var msgEl  = box && box.querySelector('[data-pf-bundle-msg]');
        if (okNames.length) {
          return afterAdd(last).then(function () {
            if (badNames.length && msgEl) {
              msgEl.textContent = oosTpl.replace('[title]', badNames.join(', '));
              if (errBox) errBox.hidden = false;
            }
            done(badNames.length ? 'is-err' : 'is-ok');
            openDrawer();
          });
        }
        if (msgEl) { msgEl.textContent = failTx; if (errBox) errBox.hidden = false; }
        toast(failTx, 'err');
        done('is-err');
      });
    }

    /* ── ONE delegated click handler for the whole section ─────────────── */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var thumb = t.closest('[data-pf-thumb]');
      if (thumb) { e.preventDefault(); show(thumbs.indexOf(thumb), true); return; }

      if (t.closest('[data-pf-tprev]')) { pageThumbs(-1); return; }
      if (t.closest('[data-pf-tnext]')) { pageThumbs(1);  return; }
      if (t.closest('[data-pf-prev]'))  { e.preventDefault(); show(at - 1, true); return; }
      if (t.closest('[data-pf-next]'))  { e.preventDefault(); show(at + 1, true); return; }

      var choice = t.closest('[data-pf-choice]');
      if (choice) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
        e.preventDefault();
        choose(Number(choice.dataset.pfPos), choice.dataset.pfVal);
        return;
      }

      var badd = t.closest('[data-pf-bundle-add]');
      if (badd) { e.preventDefault(); bundleAdd(badd); return; }

      if (lb && stage && t.closest('[data-pf-stage]') && !t.closest('[data-pf-nav]')) {
        if (swiped) return;
        e.preventDefault();
        openLb(at, stage);
      }
    });

    root.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-pf-select]');
      if (s) choose(Number(s.dataset.pfPos), s.value);
    });

    /* COMPLEMENTARY PAIR — filled from the API, not from Liquid.
       Shopify keeps the merchant's Complementary products in the reserved
       shopify--discovery--product_recommendation namespace, which templates cannot
       read, so the pair a merchant picks in Search & Discovery is invisible to
       Liquid. The block therefore renders hidden and is filled here from
       /recommendations/products.json?intent=complementary, which returns exactly
       that curation. If it returns nothing the block simply stays hidden — a
       product without a pair should not advertise one. */
    function fillComplementaryPair() {
      var shell = root.querySelector('[data-pf-bundle-fetch]');
      if (!shell || shell.dataset.pfBundleFetched === '1') return;
      shell.dataset.pfBundleFetched = '1';
      var pid = shell.dataset.pfBundleFetch;
      if (!pid) return;
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) +
            '&limit=4&intent=complementary')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          /* never pair a product with itself, and never offer one that cannot be bought */
          var mate = null;
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(pid)) continue;
            var mv = (list[i].variants || []).filter(function (x) { return x.available; })[0];
            if (mv) { mate = list[i]; mate.__v = mv; break; }
          }
          if (!mate) return;                       /* stays hidden — correct */

          shell.dataset.pfBundleMate = mate.__v.id;
          shell.dataset.pfBundleMatePrice = mate.__v.price;

          /* href only — never textContent here. The image anchor also carries
             data-pf-bundle-href and holds the two <img> children; assigning
             textContent to it replaces those children with a text node and the
             thumbnails vanish. The title is set on its own element below. */
          shell.querySelectorAll('[data-pf-bundle-href]').forEach(function (a) {
            a.setAttribute('href', mate.url);
          });
          var titleLink = shell.querySelector('.bndl-b a');
          if (titleLink) titleLink.textContent = mate.title;

          var img = shell.querySelector('[data-pf-bundle-img]');
          var src = mate.featured_image || (mate.images || [])[0];
          if (img && src) {
            img.setAttribute('src', String(src).replace(/(\.[a-z]+)(\?|$)/i, '_132x$1$2'));
            img.removeAttribute('hidden');
          }

          var totalEl = shell.querySelector('[data-pf-bundle-total]');
          if (totalEl && totalEl.dataset.pfBundleTpl) {
            var mainPrice = Number(shell.dataset.pfBundleMainPrice) ||
                            (window.__ntlPfPrice || 0);
            totalEl.textContent = totalEl.dataset.pfBundleTpl
              .replace('[total]', money(mainPrice + Number(mate.__v.price)));
          }
          var addBtn = shell.querySelector('.bndl-a');
          if (addBtn && addBtn.disabled) {
            addBtn.disabled = false;
            addBtn.removeAttribute('aria-disabled');
            addBtn.setAttribute('data-pf-bundle-add', '');
            if (shell.dataset.pfBundleCta) addBtn.textContent = shell.dataset.pfBundleCta;
          }
          shell.removeAttribute('hidden');
        });
    }

    /* the server already rendered the right variant — only wire the state up */
    syncChoices();
    syncThumbNav();
    /* runs once on load: the pair does not depend on the chosen variant */
    fillComplementaryPair();
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(syncThumbNav).catch(function () {});
    }
  }

  /* ── boot ──────────────────────────────────────────────────────────── */
  function boot(scope) {
    var nodes;
    if (scope && scope.nodeType === 1) {
      nodes = $$('[data-ntl-pfold]', scope);
      if (scope.hasAttribute && scope.hasAttribute('data-ntl-pfold')) nodes.unshift(scope);
    } else {
      nodes = $$('[data-ntl-pfold]');
    }
    nodes.forEach(function (n) {
      try { init(n); }
      catch (err) { if (window.console && console.error) console.error('[ntl-pfold]', err); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
